<template>
  <ODialog ref="dialog" :maxWidth="700" hideWhenLoading>
    <v-card>
      <ODialogBar title="Debug Cfgs" @close="dismiss" />
      <v-tabs v-model="currentTab" background-color="transparent">
        <v-tab>Lista</v-tab>
        <v-tab>JSON</v-tab>
        <v-tab>Mailbox</v-tab>
      </v-tabs>

      <v-tabs-items v-model="currentTab">
        <v-tab-item class="maxh-5">
          <SimpleConfigsViewer v-if="rows != null" :allConfigs="rows" />
        </v-tab-item>
        <v-tab-item>
          <v-card-text class="maxh-5"
            ><pre>{{ rows | prettyJson }}</pre></v-card-text
          >
        </v-tab-item>
        <v-tab-item>
          <v-card-text class="maxh-5">
            <v-btn small @click="copyMailboxToClipboard" class="mb-4">
              <v-icon small>mdi-clipboard</v-icon>
              Copiar para o Clipboard
            </v-btn>
            <pre v-if="mailboxErr">{{ mailboxErr }}</pre>
            <div v-else-if="mailbox != null">
              <pre>{{ addrLine }}</pre>
              <pre v-if="mailbox.hasError">ERROR</pre>
              <pre>{{ mailbox.previewHex }}</pre>
            </div>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </ODialog>
</template>

<script>
import { Vehicle } from '../../../models/index.js'
import SimpleConfigsViewer from './SimpleConfigsViewer.vue'
import brush from 'brush'

export default {
  components: { SimpleConfigsViewer },
  data() {
    return {
      currentTab: 0,
      rows: [],
      mailbox: null,
      mailboxErr: null,
      vehicleId: null
    }
  },
  computed: {
    addrLine() {
      if (this.mailbox == null) return null
      let a = this.mailbox.address.toString(16).padStart(4, '0')
      let h = this.mailbox.previewHex
      let l = brush.hexToBytes(h).length
      return `STORE 0x${a} (${l} bytes)\n\n`
    }
  },
  methods: {
    open(vehicleId, rows) {
      this.vehicleId = vehicleId
      this.rows = rows
      this.$refs.dialog.$loading(() => this.fetchHex())
      this.$refs.dialog.$open()
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    async fetchHex() {
      try {
        this.mailboxErr = null
        let res = await Vehicle.getConfigsHex(this.vehicleId)
        this.mailbox = res
      } catch (err) {
        this.mailboxErr = err
      }
    },

    copyMailboxToClipboard() {
      if (this.mailbox == null) return null

      let address = this.mailbox.address
      let hex = this.mailbox.previewHex

      let mailboxContents = {
        information: 'configsV2',
        label: `ConfigsV2: (vehicle #${this.vehicleId})`,
        originJson: {
          vehicleId: this.vehicleId,
          allConfigs: this.mailbox.allConfigs,
          address,
          bytes: hex
        }
      }

      navigator.clipboard.writeText(JSON.stringify(mailboxContents, null, ' '))
      this.$snack(`Mailbox copiado`)
    }
  }
}
</script>

<style></style>
